import { observer } from 'mobx-react';
import * as React from 'react';
import { DragDropContext, Droppable, DroppableProvided } from '@hello-pangea/dnd';
import { T, notYetTranslatedText } from '../../../../../../../Translations';
import Accordion from '../../../../../../Accordion';
import LearningCollectionEditStore from '../../../Store';
import { browseAllContext } from '../../../../Types';
import DeletedExperiences from './DeletedExperiences';
import Experiences from './Experiences';

interface Props {
  store: LearningCollectionEditStore;
}

const BrowseAll: React.FC<Props> = ({ store }) => {
  return (
    <div className="border-b">
      <Accordion title={notYetTranslatedText('Browse All')}>
        <>
          <div className="border border-gray-200 bg-gray-50 px-7 py-7">
            <p className="mb-4 text-sm font-semibold">
              <T kind="Programs" />
            </p>
            <table className="w-full">
              <DragDropContext onDragEnd={store.handleOnDragEndBrowseAll}>
                <Droppable droppableId="characters">
                  {(provided: DroppableProvided) => {
                    return (
                      <tbody
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        className="border-0"
                      >
                        <Experiences context={browseAllContext()} store={store} />
                        {provided.placeholder}
                      </tbody>
                    );
                  }}
                </Droppable>
              </DragDropContext>
              <tbody>
                <DeletedExperiences context={browseAllContext()} learningCollectionStore={store} />
              </tbody>
            </table>
          </div>
        </>
      </Accordion>
    </div>
  );
};

export default observer(BrowseAll);
